<template>
  <div class="sale-banner">
    <div v-if="!sale.video_description.length">
      <div class="text_large">{{ i18n.sale_video_empty_header() }}</div>
    </div>
    <template v-else>
      <div class="sale-banner__video" v-for="(url, index) in embedVideoUrls" :key="index">
          <md-card>
            <md-card-media>
              <iframe
                style="width: 100%; height: 100%"
                :src="url"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
            </md-card-media>
          </md-card>
        </div>
    </template>
  </div>
</template>

<script>
  import { i18n } from '@js/i18n'

  export default {
    name: 'sale-banner',
    props: ['sale'],
    data: _ => ({
      i18n
    }),

    computed: {
      embedVideoUrls () {
        let url = this.sale.video_description ? this.sale.video_description.map((item) => {
          return `https://www.youtube.com/embed/${item}`
        }) : []
        return url
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  .sale-banner {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: space-between;
  }

  .sale-banner__video {
    width: 50%;
    padding: 0.5% 1%;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_details/components/Sales.Banner.vue